import React from 'react'
import SettingApiForm from '../components/setting/settingsCdnForm'

const SettingsCdn = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingsCdn